import { Globe } from 'lucide-react';

export const wordpressIntegration = {
    id: 'wordpress',
    name: 'WordPress',
    icon: Globe,
    platformColor: '#21759B',
    title: 'WordPress Setup',
    why: 'Integrating chatbots with your WordPress site brings numerous benefits, from enhanced support and availability to personalized user experiences.',
    detailedGuide: '/docs/wordpress',
    tabs: [
        {
            id: 'plugin',
            label: 'Using Plugin',
            content: {
                desc: 'This method is the easiest way to add ChytBot to your WordPress website, especially if you’re not comfortable editing code.',
                steps: [
                    {
                        title: "Copy the Code Snippet",
                        desc: "A text box with your unique chatbot code will appear. Click the \"Copy Code\" button to ensure you capture the entire snippet.",
                        image: "/docs/screenshots/wordpress/integration.jpg",
                        imgAlt: "Copying the embed code"
                    },
                    {
                        title: "Install Headers & Footers Plugin",
                        desc: "In your WordPress Dashboard, go to Plugins > Add New. Search for \"Insert Headers and Footers\" by WPBrigade. Install and Activate it.",
                        image: "/docs/screenshots/wordpress/insert_headers_and_footers.png",
                        imgAlt: "Installing WP Headers and Footers"
                    },
                    {
                        title: "Add Code to Header",
                        desc: "Go to Settings > WP Headers and Footers. Paste your ChytBot code into the \"Scripts in Header\" section.",
                        image: "/docs/screenshots/wordpress/WP_headers_and_footers.png",
                        imgAlt: "Pasting code into header"
                    },
                    {
                        title: "Save & Verify",
                        desc: "Click \"Save Changes\". Your ChytBot is now live! Visit your homepage to confirm usage.",
                        image: "/docs/screenshots/wordpress/chytbot.png",
                        imgAlt: "Live ChytBot Verification"
                    }
                ]
            }
        },
        {
            id: 'editor',
            label: 'Theme Editor',
            content: {
                desc: 'Best for users comfortable editing theme files. This manually inserts the code into your theme header. (Classic Themes Only)',
                steps: [
                    {
                        title: "Get Your Embed Code",
                        desc: "Follow the initial steps to access and copy your ChytBot embed code from the dashboard.",
                        image: "/docs/screenshots/wordpress/embed_code.png",
                        imgAlt: "Get embed code"
                    },
                    {
                        title: "Access Theme File Editor",
                        desc: "In your WordPress dashboard, navigate to Appearance > Theme File Editor.",
                        image: "/docs/screenshots/wordpress/theme_file_editor.png",
                        imgAlt: "Theme File Editor"
                    },
                    {
                        title: "Locate header.php",
                        desc: "On the right side, scroll through the theme files and click on \"Theme Header (header.php)\".",
                        image: "/docs/screenshots/wordpress/theme_header.png",
                        imgAlt: "Selecting header.php"
                    },
                    {
                        title: "Insert Code Snippet",
                        desc: "Scroll to find the closing </head> tag. Paste your ChytBot code just before this tag.",
                        image: "/docs/screenshots/wordpress/insert_chybot_embed_code.png",
                        imgAlt: "Inserting code"
                    },
                    {
                        title: "Update File",
                        desc: "Click \"Update File\" to save your changes. Your bot should now be visible on your site.",
                        image: "/docs/screenshots/wordpress/chytbot.png",
                        imgAlt: "Success"
                    }
                ]
            }
        },
        {
            id: 'elementor',
            label: 'Elementor',
            content: {
                desc: 'If using Elementor Pro, you can use the built-in Custom Code feature for precise control.',
                steps: [
                    {
                        title: "Navigate to Custom Code",
                        desc: "In your WordPress sidebar, go to Elementor > Custom Code.",
                        image: "/docs/screenshots/wordpress/wordpress_dashboard.png",
                        imgAlt: "WordPress Dashboard"
                    },
                    {
                        title: "Add New Custom Code",
                        desc: "Click the \"Add New Custom Code\" button to create a new script entry.",
                        image: "/docs/screenshots/wordpress/create_code_snippit.png",
                        imgAlt: "Add New Code"
                    },
                    {
                        title: "Configure Snippet",
                        desc: "Title it \"ChytBot\", select location \"<head>\", and paste your embed code.",
                        image: "/docs/screenshots/wordpress/enter_custom_code.png",
                        imgAlt: "Entering code details"
                    },
                    {
                        title: "Set Conditions",
                        desc: "Click Publish. In the conditions window, confirm it is set to \"Entire Site\" so the bot appears everywhere.",
                        image: "/docs/screenshots/wordpress/public_settings.png",
                        imgAlt: "Publish settings"
                    },
                    {
                        title: "Publish & Activate",
                        desc: "Click \"Save & Close\" or \"Publish\" to activate your chatbot.",
                        image: "/docs/screenshots/wordpress/publish.png",
                        imgAlt: "Publishing"
                    }
                ]
            }
        }
    ]
};
